<div class="container-planos" *ngIf="planosAlimentares && planosAlimentares.length > 0">
  <div class="plano-alimentar" *ngFor="let plano of planosAlimentares">
    <div class="dados-plano">
      <div [ngClass]="plano.status === statusAtivo ? 'ativo' : plano.status === statusRascunho ? 'rascunho' : 'expirado'">
        <p>{{ obterStatusLabel(plano.status) }}</p>
      </div>

      <p class="caracteristicas" *ngIf="plano.caracteristicas?.length">{{ plano.caracteristicas.join(', ') }}</p>

      <p *ngIf="plano.condicoesClinicas">Condições clínicas específicas: {{plano.condicoesClinicas}}</p>

      <div class="wrap-datas" *ngIf="plano.periodo">
        <img alt="calendario" src="../../../../assets/svg/icons/calendario.svg">
        <p>{{plano.periodo.inicio}} a {{plano.periodo.fim}}</p>
      </div>
    </div>

    <button class="acessar-plano-btn" (click)="acessarPlano(plano)">
      Acessar
    </button>
  </div>
</div>

<p class="sem-registro" *ngIf="!planosAlimentares || planosAlimentares.length === 0">
  Nenhum plano alimentar adicionado.
</p>